/**
 *
 * LoadingLayout
 *
 */

import { stylize } from "@envestnet/envreact-component-library";
import classnames from "classnames";
import PageLoadingComponent from "components/PageLoadingComponent";
import React, { useEffect } from "react";
import { UserInfo } from "types/UserInfo";
import withIntl from "utils/withIntl";
import storage from "../../persistance";

import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;

  goToDashboard: (resource: string) => void;

  userInfo: UserInfo;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
}

export interface LoadingLayoutProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;
}

const defaultProps: DefaultProps = {};

type Props = InjectedProps & LoadingLayoutProps;

const LoadingLayout = (props: Props) => {
  const { classes, style, className, innerRef, goToDashboard, userInfo } =
    props;

  const resourceId = new URLSearchParams(window.location.search).get(
    "resourceId"
  );

  useEffect(() => {
    if ((userInfo as UserInfo).email !== "") {
      const state = storage.getItem("resourceId");
      if (resourceId && !state) {
        goToDashboard(resourceId);
      } else {
        goToDashboard(state ?? "");
      }
    }
  }, [userInfo]);

  return (
    <div
      ref={innerRef}
      className={classnames(
        className,
        classes.container,
        "header-text-font-family"
      )}
      style={style}
      data-testid="information-loading"
    >
      <PageLoadingComponent />
    </div>
  );
};

LoadingLayout.defaultProps = defaultProps;

export default withIntl(stylize<Props, DefaultProps>(styles)(LoadingLayout));
